<template>
  <div class="fashion-part">
    <div :class="wrapClasses">
      <div class="list-wrap">
        <ul class="list from-bottom">
          <CategoryItem
            v-for="(cat, index) in categoriesTop"
            :key="index"
            v-bind="cat"
            alt
          />
        </ul>
        <ul class="list from-top">
          <CategoryItem
            v-for="(cat, index) in categoriesBottom"
            :key="index"
            v-bind="cat"
            alt
          />
        </ul>
      </div>
    </div>
    <div class="button-wrap">
      <button
        @click="togglePart"
        class="button"
      >
        <span class="text">{{ toggleText }}</span>
        <svg :class="chevronClasses" width="14" height="9" xmlns="http://www.w3.org/2000/svg"><path d="M1 1.847l5.91 5.91 5.91-5.91" stroke="#FFF" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>
      </button>
    </div>
  </div>
</template>

<script>
import { FashionAlt, Shoes, Jewels, Underwear } from './icons'
import CategoryItem from './CategoryItem'
import { trackAccordion } from '@/utils/track'

export default {
  name: 'FashionPart',
  data () {
    return {
      open: false,
      tracked: false,
      toggleText: 'Open voor meer',
      categoriesTop: [{
        name: 'Kleding',
        value: 40,
        strips: 8,
        icon: FashionAlt
      }, {
        name: 'Schoenen',
        value: 30,
        strips: 6,
        icon: Shoes
      }],
      categoriesBottom: [{
        name: 'Sieraden en horloges',
        value: 20,
        strips: 4,
        icon: Jewels
      }, {
        name: 'Ondergoed en lingerie',
        value: 15,
        strips: 3,
        icon: Underwear
      }]
    }
  },
  components: {
    CategoryItem
  },
  methods: {
    togglePart () {
      this.open = !this.open
      this.toggleText = this.open ? 'Sluiten' : 'Open voor meer'

      if (!this.tracked) {
        trackAccordion('chapter-1-wat-bestellen-we-het-meest')
        this.tracked = true
      }
    },
    flipInClass (index) {
      return (index < 3) ? 'from-bottom' : 'from-top'
    }
  },
  computed: {
    chevronClasses () {
      return {
        'chevron': true,
        'turned': this.open
      }
    },
    wrapClasses () {
      return {
        'wrap': true,
        'open': this.open
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.fashion-part {
  margin: 2.5em 0 1em;
}

.wrap {
  overflow: hidden;
  transition: all 1s cubic-bezier(.19,1,.22,1);
  max-height: 0px;
  border-top: 1px dashed $c-dark;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    bottom: 50%;
    height: 100px;
    background: linear-gradient(to top, rgba($c-dark, 0.06), rgba($c-dark, 0));
    left: 0;
    right: 0;
  }
}

.from-bottom,
.from-top {
  transition: all 1s cubic-bezier(.19,1,.22,1);
  transition-property: opacity, transform;
  will-change: opacity, transform;
  backface-visibility: hidden;
}

.from-bottom {
  transform: rotateX(70deg) translateY(-250px);
  transform-origin: 0% 100%;
  opacity: 0.4;
}

.from-top {
  transform: rotateX(-70deg) translateY(-250px);
  transform-origin: 0% 0%;
  opacity: 0.4;
}

.open {
  max-height: 500px;

  .from-bottom,
  .from-top {
    transform: rotateX(0deg);
    opacity: 1;
  }
}

.list-wrap {
  padding: 30px 0 16px;
  background-color: $c-pink;
}

.list {
  margin: 0;
  padding: 0;
}

.button-wrap {
  text-align: center;
  position: relative;
  margin-top: -16px;

  &::before {
    content: '';
    position: absolute;
    bottom: 16px;
    left: 0;
    right: 0;
    border-bottom: 1px dashed $c-dark;
  }
}

.button {
  background: $c-dark;
  border-radius: 16px;
  line-height: 32px;
  width: 172px;
  text-align: center;
  border: none;
  color: white;
  font-size: 16px;
  margin: 0 auto;
  padding: 0;
  position: relative;
  z-index: 2;
  cursor: pointer;
  outline: 0;
}

.turned {
  transform: rotate(180deg);
}

.text {
  margin-right: 10px;
}
</style>
